"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _MultipartUpload_1 = require("./_MultipartUpload");
exports._MultipartUploadList = {
    type: "list",
    flattened: true,
    member: {
        shape: _MultipartUpload_1._MultipartUpload
    }
};
//# sourceMappingURL=_MultipartUploadList.js.map